import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { guideCategories, localized } from '../../data/guides/guidesRegistry';
import { GuideIcon } from '../ui/GuideIcons';
import './GuideTiles.css';
/**
 * Anleitungen als Kacheln mit Themen-Icon, nach Kategorie in Zeilen gruppiert.
 * Genutzt im Hilfe-Center und auf der Produktseite.
 */
const GuideTiles = ({ guides, showDescription = true, anchors = false, }) => {
    const { i18n } = useTranslation();
    const lang = (i18n.language || 'en').split('-')[0];
    return (_jsx("div", { className: "guide-rows", children: guideCategories.map((cat) => {
            const list = guides.filter((g) => g.category === cat.id);
            if (!list.length)
                return null;
            return (_jsxs("div", { id: anchors ? cat.id : undefined, className: "guide-row", children: [_jsx("h3", { className: "guide-row-title", children: localized(cat.label, lang) }), _jsx("ul", { className: `guide-tiles ${showDescription ? "" : "guide-tiles-compact"}`, children: list.map((g) => (_jsx("li", { children: _jsxs(Link, { to: g.route, className: "guide-tile frame-hover", children: [_jsx("span", { className: "icon-tile frame", children: _jsx(GuideIcon, { id: g.id, size: 30 }) }), _jsxs("span", { className: "guide-tile-text", children: [_jsx("span", { className: "guide-tile-title", children: localized(g.title, lang) }), showDescription && _jsx("span", { className: "guide-tile-desc", children: localized(g.description, lang) })] })] }) }, g.id))) })] }, cat.id));
        }) }));
};
export default GuideTiles;
